import AppFrontendsIndex from "./frontend.vue";
import AppFrontendsList from "./list/list.vue";

const routes = [
  {
    path: "/",
    component: AppFrontendsIndex,
    children: [
      {
        path: "",
        name: "frontend.index",
        component: AppFrontendsList
      }
    ]
  }
];

export default routes;
